// AppShell.jsx
"use client";

import React, { Suspense, useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import GlobalNav from "./components/GlobalNav";
import ScrollToTop from "./components/ScrollToTop";

// 懒加载四个板块
const Aesthetics  = React.lazy(() => import("./sections/Aesthetics"));  // 重述美学
const Tradition   = React.lazy(() => import("./sections/Tradition"));   // 重述传统
const Innovation  = React.lazy(() => import("./sections/Innovation"));  // 重述革新
const Craft       = React.lazy(() => import("./sections/Craft"));       // 重述匠心

export default function AppShell() {
  // 保留你原来的全局副作用
  useEffect(() => {
    const preventHorizontalScroll = (e) => { if (e.deltaX !== 0) e.preventDefault(); };
    document.documentElement.style.overflowX = "hidden";
    document.body.style.overflowX = "hidden";
    document.documentElement.style.touchAction = "pan-y";
    document.body.style.touchAction = "pan-y";
    window.addEventListener("wheel", preventHorizontalScroll, { passive: false });
    return () => window.removeEventListener("wheel", preventHorizontalScroll);
  }, []);

  return (
    <>
      <GlobalNav />
      <ScrollToTop />
      <Suspense fallback={<div style={{ paddingTop: 64, textAlign: "center" }}>Loading…</div>}>
        <Routes>
          {/* 中文主站路由（保持原样） */}
          <Route path="/"            element={<Navigate to="/Aesthetics" replace />} />
          <Route path="/Aesthetics"  element={<Aesthetics />} />
          <Route path="/Tradition"   element={<Tradition />} />
          <Route path="/Innovation"  element={<Innovation />} />
          <Route path="/Craft"       element={<Craft />} />

          {/* 新增：英文路由，同样指向同一组 sections 组件 */}
          <Route path="/en"               element={<Navigate to="/en/Aesthetics" replace />} />
          <Route path="/en/Aesthetics"    element={<Aesthetics />} />
          <Route path="/en/Tradition"     element={<Tradition />} />
          <Route path="/en/Innovation"    element={<Innovation />} />
          <Route path="/en/Craft"         element={<Craft />} />

          {/* 404 兜底：分别兜底到中英文各自首页 */}
          <Route path="/en/*"        element={<Navigate to="/en/Aesthetics" replace />} />
          <Route path="*"            element={<Navigate to="/Aesthetics" replace />} />
        </Routes>
      </Suspense>
    </>
  );
}
